import { required } from 'vuelidate/lib/validators'

const requiredMsg = 'Обязательное поле'

export default (vars) => {
  return {
    displayName: { required: { validator: required, message: requiredMsg } },
    name: { required: { validator: required, message: requiredMsg } },
    type: { required: { validator: required, message: requiredMsg } }
  }
}
